import CatalogPageRenderer from './renderer'
export default CatalogPageRenderer
